import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useOpen } from '@/hooks/open';
import { DeleteFilterButton, EditFilterButton, SaveFilterButton } from '../filter-components';
import { NodeFilterDeleteModal, NodeFilterEditModal, NodeFilterSaveModal } from '../../node-filters/node-filter-modals';
import { useNodeFilterContext } from './node-filter-context';
import { isNodeFilterNew, isNodeQueryValid } from './node-filter-utils';
function NodeFilterSaveAction(_a) {
    var handlePopoverClose = _a.handlePopoverClose;
    var t = useTranslation().t;
    var _b = useOpen(), open = _b.open, handleClose = _b.handleClose, handleOpen = _b.handleOpen;
    var _c = useNodeFilterContext(), selectedFilter = _c.selectedFilter, setFilter = _c.setFilter;
    var handleSubmit = useCallback(function (smartgroup) {
        // Only apply filter if returned smartgroup is valid
        if (isNodeQueryValid(smartgroup)) {
            setFilter(smartgroup);
        }
        // Always close modal and popover
        handleClose();
        handlePopoverClose();
    }, [setFilter, handleClose, handlePopoverClose]);
    return (_jsxs(_Fragment, { children: [_jsx(NodeFilterSaveModal, { open: open, selectedFilter: !!selectedFilter && isNodeFilterNew(selectedFilter) ? selectedFilter : undefined, onClose: handleClose, onSubmit: handleSubmit, translations: {
                    dialogTitle: t('components.nodes.filter.save_modal.title'),
                    saveBtn: t('global.buttons.save_and_apply'),
                } }), _jsx(SaveFilterButton, { label: t('components.nodes.filter.button.save'), onClick: handleOpen })] }));
}
function NodeFilterEditAction(_a) {
    var handlePopoverClose = _a.handlePopoverClose;
    var t = useTranslation().t;
    var _b = useOpen(), open = _b.open, handleClose = _b.handleClose, handleOpen = _b.handleOpen;
    var _c = useOpen(), deleteOpen = _c.open, handleDeleteClose = _c.handleClose, handleDeleteOpen = _c.handleOpen;
    var _d = useNodeFilterContext(), isSelectedFilterApplied = _d.isSelectedFilterApplied, selectedFilter = _d.selectedFilter, dispatchSelectedFilter = _d.dispatchSelectedFilter, setFilter = _d.setFilter;
    var handleDelete = useCallback(function () {
        // Only clear applied filter and close popover if applied filter is being deleted
        if (isSelectedFilterApplied) {
            setFilter(null);
            handlePopoverClose();
        }
        // Always clear selected filter
        dispatchSelectedFilter({ type: 'clear' });
        // Always close delete confirm and edit modal
        handleDeleteClose();
        handleClose();
    }, [setFilter, dispatchSelectedFilter, handleClose, handleDeleteClose, handlePopoverClose, isSelectedFilterApplied]);
    var handleSubmit = useCallback(function (smartgroup) {
        // Only apply filter if returned smartgroup is valid
        if (isNodeQueryValid(smartgroup)) {
            setFilter(smartgroup);
        }
        // Always close edit modal and popover
        handleClose();
        handlePopoverClose();
    }, [setFilter, handleClose, handlePopoverClose]);
    return (_jsxs(_Fragment, { children: [selectedFilter && _jsx(NodeFilterDeleteModal, { open: deleteOpen, onClose: handleDeleteClose, onDelete: handleDelete, selectedFilter: selectedFilter }), _jsx(NodeFilterEditModal, { open: open, selectedFilter: !!selectedFilter && isNodeQueryValid(selectedFilter) ? selectedFilter : undefined, onClose: handleClose, onDelete: handleDeleteOpen, onSubmit: handleSubmit, translations: {
                    dialogTitle: t('components.nodes.filter.edit_modal.title'),
                    saveBtn: t('global.buttons.save_and_apply'),
                } }), _jsx(EditFilterButton, { label: t('components.nodes.filter.button.edit'), onClick: handleOpen })] }));
}
function NodeFilterDeleteAction() {
    var t = useTranslation().t;
    var _a = useOpen(), open = _a.open, handleClose = _a.handleClose, handleOpen = _a.handleOpen;
    var _b = useNodeFilterContext(), selectedFilter = _b.selectedFilter, dispatchSelectedFilter = _b.dispatchSelectedFilter;
    var handleDelete = useCallback(function () {
        // Always clear selected filter
        dispatchSelectedFilter({ type: 'clear' });
        // Always close delete confirm
        handleClose();
    }, [dispatchSelectedFilter, handleClose]);
    return (_jsxs(_Fragment, { children: [selectedFilter && _jsx(NodeFilterDeleteModal, { open: open, onClose: handleClose, onDelete: handleDelete, selectedFilter: selectedFilter }), _jsx(DeleteFilterButton, { label: t('components.nodes.filter.button.delete'), onClick: handleOpen })] }));
}
export function NodeFilterActions(_a) {
    var handlePopoverClose = _a.handlePopoverClose;
    var selectedFilter = useNodeFilterContext().selectedFilter;
    if (!selectedFilter)
        return null;
    if (isNodeFilterNew(selectedFilter)) {
        return _jsx(NodeFilterSaveAction, { handlePopoverClose: handlePopoverClose });
    }
    if (isNodeQueryValid(selectedFilter)) {
        return _jsx(NodeFilterEditAction, { handlePopoverClose: handlePopoverClose });
    }
    return _jsx(NodeFilterDeleteAction, {});
}
